export default {
	id: 'SIMPLE_PREMIUM_9M_77_97',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_9m_77_97_usd',
			ARS: 'simple_premium_9m_88900_ars',
			AUD: 'simple_premium_9m_119_99_aud',
			BRL: 'simple_premium_9m_439_brl',
			CAD: 'simple_premium_9m_99_99_cad',
			CLP: 'simple_premium_9m_72900_clp',
			COP: 'simple_premium_9m_321900_cop',
			DKK: 'simple_premium_9m_499_dkk',
			EUR: 'simple_premium_9m_77_97_eur',
			GBP: 'simple_premium_9m_77_97_gbp',
			MXN: 'simple_premium_9m_1499_mxn',
			NOK: 'simple_premium_9m_789_nok',
			PLN: 'simple_premium_9m_289_pln',
			SEK: 'simple_premium_9m_749_sek',
			TRY: 'simple_premium_9m_2900_try',
		},
		primer: 'prd_ue9A4UIfXPzi',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 9,
		intro_period_type: 'month',
		next_period_value: 9,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 9,
		priceMap: {
			USD: 77.97,
			ARS: 88900,
			AUD: 119.99,
			BRL: 439,
			CAD: 99.99,
			CLP: 72900,
			COP: 321900,
			DKK: 499,
			EUR: 77.97,
			GBP: 77.97,
			MXN: 1499,
			NOK: 789,
			PLN: 289,
			SEK: 749,
			TRY: 2900,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.9mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.9mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.9mo.bar_chart_right_label'),
	}),
}
